import { EmailAddress } from "./email-address";

export class Person {
  personId!: string;
  active!: boolean;
  createTimestamp!: Date;
  createUser!: string;
  defaultPhoneNumber!: string;
  description!: string;
  firstName!: string;
  lastName!: string;
  primaryOrgUnitId!: string;
  statusCode!: string;
  title!: string;
  typeCode!: string;
  updateTimestamp!: Date;
  updateUser!: string;
  userCustomerOrgId!: string;
  userLogin!: string;
  userTypeCode!: string;
  userVendorOrgId!: string;
  emailAddress: EmailAddress = new EmailAddress();
  supervisorId!: string;
  partSalesManagerId!: string;
}
